import React, { useContext } from 'react';
import { TaskExportConfigurationContext } from '../../../../../context/TaskExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../components/ExportItems';

export default function TaskExportConfigurationsPane() {
  const { taskExportConfigurations, taskExportConfigurationsLoading } = useContext(TaskExportConfigurationContext);

  return (
    <ExportConfigurationsPane
      configurations={[...taskExportConfigurations.values()]}
      loading={taskExportConfigurationsLoading}
    />
  );
}
